module.exports = __webpack_public_path__ + "static/media/lineto-akkurat-pro-regular-0241e83626b4a989366fd594626ff076.0241e836.woff";